import React from "react";
import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Button,
    Stack,
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import './ManagePostCard.css'
import { PostType } from "./PostApprovalScreen";
import { formatDate, updatePostStatus } from "./SocialService";

interface ManagePostCardType {
    selectedPost: PostType | undefined,
    handleUpdateStatus: (status: string, postid: string) => void
}

const ManagePostCard = ({ selectedPost, handleUpdateStatus }: ManagePostCardType) => {

    const mediaUrl = `https://d15q3m60ny32k7.cloudfront.net/${selectedPost?.mediaUrl}`;
    const isVideo = /\.(mp4|webm|ogg)$/i.test(mediaUrl);
    const isYouTube = selectedPost?.imageType == 'youtube' ? true : false;

    return (
        <div className="manage_post_parent_container">
            <Card
                sx={{
                    borderRadius: 1,
                    boxShadow: '0px 3px 6px #0000000D',
                    margin: 1,
                    padding: 1,
                    overflow: "hidden",
                }}
            >

                {isYouTube ? (
                    <iframe
                        width="100%"
                        height="150"
                        src={`https://www.youtube.com/embed/${selectedPost?.mediaUrl}`}
                        title="YouTube Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: '5px' }}
                    />
                ) :
                    <CardMedia
                        component={isVideo ? "video" : "img"}
                        height="150"
                        image={!isVideo ? mediaUrl : undefined}
                        src={isVideo ? mediaUrl : undefined}
                        controls={isVideo}
                        autoPlay={false}
                        alt=""
                        sx={{ borderRadius: '5px' }}
                    />}
                <CardContent sx={{ padding: '0 !important' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Box className='manage_post_card_header'>
                            <span className="manage_post_title">
                                {selectedPost?.outletname}
                            </span><br />
                            <span style={{ fontSize: '12px' }}>
                                {selectedPost?.name}
                            </span><br />
                            <span className="manage_post_sub_title">
                                {formatDate(selectedPost?.time ?? '')}
                                {/* 23rd May 2024 | 2:31 PM */}
                            </span>
                        </Box>
                    </Stack>

                </CardContent>

            </Card>



            <div className="manage_post_content_container" >
                {selectedPost?.content}
            </div>
            <Box
                sx={{
                    padding: '10px',
                    height: '10%',
                    display: "flex",
                    justifyContent: 'flex-end',
                    gap: 1,
                    boxShadow: '0px 3px 20px #00000010',
                    alignItems: 'center'
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => handleUpdateStatus('rejected', selectedPost?.id ?? '')}
                    startIcon={<Close sx={{ fontSize: '13px !important', }} />}
                    sx={{
                        fontSize: '12px',
                        fontWeight: '550',
                        background: '#C64C00',
                        borderRadius: '3px',
                        textTransform: "none",
                        padding: '2px 6px',
                    }}
                >
                    Reject
                </Button>
                <Button
                    onClick={() => handleUpdateStatus('accepted', selectedPost?.id ?? '')}
                    variant="contained"
                    startIcon={<Check sx={{ fontSize: '13px !important' }} />}
                    sx={{
                        fontSize: '12px',
                        fontWeight: '550',
                        background: '#00C6B1',
                        borderRadius: '3px',
                        textTransform: "none",
                        padding: '2px 6px'
                    }}
                >
                    Approve
                </Button>
            </Box>
        </div>
    );
};

export default ManagePostCard;
